const _ = require('lodash');
const { default: Axios } = require('axios');
const Configuration = {

    nearpeerApi: {

        shouldUseMock: () => _.isUndefined(Configuration.nearpeerApi.baseUrl()),

        // #region nearpeer-api-root-base-url
/*
@np-doc
id: frontend.config.root-api-base-url
title: Root API base URL
section: Platform
order: 20
summary: Derives the API root host without API_PREFIX for root-level routes like /docs/session.
tags: config,docs,api
*/
        rootBaseUrl: () => {

            if (process.env.API_HOST === 'USE-MOCK') {
                return undefined;
            }

            const host = process.env.API_HOST || 'https://staging.nearpeer.net';

            // Seems like the 'host' is coming with double quotes surrounding it
            return String(host).replaceAll('"', '');
        },
/* @np-doc-end */
        // #endregion nearpeer-api-root-base-url

        baseUrl: () => {

            if (process.env.API_HOST === 'USE-MOCK') {
                return undefined;
            }

            const host =   process.env.API_HOST   || 'https://staging.nearpeer.net';
            const prefix = process.env.API_PREFIX || '/api';

            // Seems like the 'host' is coming with double quotes surrounding it
            return String(`${host}${prefix}`).replaceAll('"', '');
        },

        // #region nearpeer-api-root-http-client
/*
@np-doc
id: frontend.config.root-http-client
title: Root API HTTP client
section: Platform
order: 30
summary: Creates the Axios client used for root-level API routes that should not be prefixed with /api.
tags: config,docs,api
*/
        makeRootHttp: () => {

            if (Configuration.nearpeerApi.shouldUseMock()) {

                return require('./mocks/nearpeer-http').makeNearPeerHttpMock();
            }

            return Axios.create({ baseURL: Configuration.nearpeerApi.rootBaseUrl() });
        },
/* @np-doc-end */
        // #endregion nearpeer-api-root-http-client

        makeHttp: () => {

            if (Configuration.nearpeerApi.shouldUseMock()) {

                return require('./mocks/nearpeer-http').makeNearPeerHttpMock();
            }

            return Axios.create({ baseURL: Configuration.nearpeerApi.baseUrl() });
        }
    },
    analyticsApi: {

        baseUrl: () => {

            const host =   process.env.ANALYTICS_API_HOST   || 'http://localhost:4444';
            const prefix = process.env.ANALYTICS_API_PREFIX || '/api';

            // Seems like the 'host' is coming with double quotes surrounding it
            return String(`${host}${prefix}`).replaceAll('"', '');
        },
        makeHttp: () => {

            return Axios.create({ baseURL: Configuration.analyticsApi.baseUrl() });
        }
    },
    twilioApi: {
        environmentPrefix: process.env.TWILIO_ENV || 'staging'
    },
    firebase: {
        senderId: process.env.FIREBASE_SENDER_ID
    }
};

module.exports = Configuration;
